/* eslint-disable */
import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

const MainStyles = ({ theme }) => {
  return (
    <GlobalStyles
      styles={{
        '.PageContainerSmall': {
          width: '800px',
        },
        '.PageContainerSmallInner': {
          padding: '0 48px',
        },
        '.InputTypeTextarea textarea.MuiInputBase-inputMultiline': {
          height: '23px!important',
          overflow: 'auto!important',
          maxHeight: '23px!important',
        },
        '.AutocompleteCheck': {
          '& .MuiAutocomplete-option': {
            cursor: 'pointer',
            '& svg': {
              opacity: '0',
              position: 'absolute',
              right: '16px',
            },
            '&:hover svg, &[data-focus="true"] svg, &[aria-selected="true"] svg, &:focus svg': {
              opacity: '1',
            },
          },
        },
        '.TableFormat': {
          maxHeight: '300px',
          overflowX: 'auto',
        },
        '.RowLoop': {
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          width: '100%',
          justifyContent: 'space-between',
          marginBottom: '16px',
        },
        '.MuiAutocomplete-listbox li:last-child .MuiAutocomplete-groupUl': {
          border: 'none',
          paddingBottom: '0px',
          marginBottom: '0px',
        },
        '.RowLoop > *': {
          flex: '1',
        },
        '.NoSortArrow .MuiDataGrid-sortIcon': {
          display: 'none',
        },
        '.CustomTab .MuiTabPanel-root': {
          backgroundColor: theme.palette.background.dark,
        },
        '.CustomTab .MuiTabs-root': {
          paddingLeft: '16px',
          paddingRight: '16px',
          backgroundColor: theme.palette.background.default,
        },
        '.FixedCustomTab .FixedCustomTabHeader': {
          position: 'sticky',
          top: '74px',
          zIndex: '99',
          borderBottom: '1px solid',
          borderColor: theme.palette.divider,
        },
        '.FixedCustomHeader': {
          position: 'fixed',
          top: '0px',
          zIndex: '99',
          transition: 'top 0.2s ease-in-out',
        },
        '.FixedCustomHeader.scrolled': {
          top: '74px',
        },
        '.AppLayoutNavOpen .FixedCustomHeader': {
          width: 'calc(100% - 240px)',
        },
        '.AppLayoutNavClose .FixedCustomHeader': {
          width: 'calc(100% - 65px)',
        },
        '.BreadcrumbsFirstSequence': {
          color: theme.palette.text.secondary,
        },
        '.BreadcrumbsIcon': {
          marginRight: '8px',
        },
        '.OverlineHeading': {
          marginBottom: '8px',
        },
        '.AutoCompleteDisabled': {
          opacity: '0.6',
        },
        '.MuiDataGrid-panel .MuiPaper-root': {
          '& .MuiDataGrid-panelHeader': {
            display: 'none',
          },
          '& .MuiDataGrid-panelContent': {
            '& .MuiDataGrid-columnsPanel': {
              padding: '0px',
              '& .MuiDataGrid-columnsPanelRow': {
                minHeight: '38px',
                '&:hover': {
                  backgroundColor: theme.palette.primary.hover,
                },
                '& .MuiFormControlLabel-root': {
                  paddingLeft: '0px',
                  margin: '0px',
                  width: '100%',
                },
              },
            },
          },
        },
        '.MuiDateRangeCalendar-root': {
          '& div:nth-of-type(1)': {
            zIndex: '0!important',
          },
          '& .MuiDateRangeCalendar-monthContainer': {
            backgroundColor: '#fff',
            zIndex: '10',
          },
        },
        '.ToolbarBox': {
          display: 'flex',
          alignItems: 'center',
          paddingBottom: '8px',
          paddingTop: '4px',
          '& .MuiDataGrid-toolbarContainer:first-of-type': {
            '& .MuiButtonBase-root.MuiButton-root:nth-of-type(2)': {
              // display: 'none',
            },
            '& .MuiButtonBase-root.MuiButton-root + .MuiBox-root': {
              display: 'none',
            },
          },
        },
        '.WrapperBox': {
          // height: '100%',
          minHeight: '100vh',
        },
        '.WrapperBoxSecond': {
          minHeight: 'calc(100vh - 74px)',
        },
        '.CommonDatePicker': {
          '& .MuiStack-root': {
            paddingTop: '0px',
            overflow: 'visible',
          },
          '& .MuiStack-root .MuiTextField-root': { width: '100%' },
        },
        '.CustomFieldIcon': {
          position: 'relative',
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '12px 12px 12px 40px!important',
          },
          '& .MuiFormControl-root.MuiTextField-root .MuiFormLabel-root': {
            transform: 'translate(40px, 14px) scale(1)',
          },
          '& .MuiFormControl-root.MuiTextField-root .MuiFormLabel-root.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
        },
        '.searchInputFld': {
          '& .MuiSvgIcon-root': {
            color: 'rgba(0, 0, 0, 0.56)',
          },
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '8.5px 12px 8.5px 12px !important',
          },
        },
        '.CustomIconLeft': {
          position: 'absolute',
          zIndex: '99',
          top: '10px',
          left: '10px',
          transform: 'translate(0%, 0%)',
        },
        '.ActionIconButton': {
          border: '2px solid',
          borderColor: 'transparent',
          color: theme.palette.action.active,
          fontSize: '10px',
          '&:hover': {
            borderColor: theme.palette.action.active,
            backgroundColor: theme.palette.action.focus,
          },
          '&[aria-describedby="action-popover"]': {
            borderColor: theme.palette.action.active,
            backgroundColor: theme.palette.action.focus,
          },
          '& svg': {
            fontSize: '22px',
          },
        },
        '.RadioGroupWrapper .MuiFormControlLabel-root': {
          width: 'calc(50% - 0px)',
        },
        '.RadioGroupWrapper .MuiFormControlLabel-root:last-child': {
          marginRight: '0px',
        },
        '.DialogActionsCorner': {
          justifyContent: 'space-between',
        },
        '.MainDrawer .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar': {
          width: '1px',
        },
        '.MainDrawer .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb': {
          background: theme.palette.common.neutral.main,
        },
        '.MainDrawer .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-track': {
          backgroundColor: theme.palette.common.neutral.main,
        },
        '.MainDrawer .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb': {
          background: theme.palette.common.neutral.main,
        },
        '.AppLayoutNavOpen': {
          maxWidth: 'calc(100% - 240px)',
          [theme.breakpoints.down('sm')]: {
            maxWidth: 'calc(100% - 0px)',
          },
        },
        '.AppLayoutNavClose': {
          maxWidth: 'calc(100% - 65px)',
          [theme.breakpoints.down('md')]: {
            maxWidth: 'calc(100% - 0px)',
          },
        },
        '.ChipNoBorder, .NoBorder': {
          border: 'none!important',
        },
        // '.PopoverCustom .MuiPaper-root.MuiPopover-paper': {
        //   top: '68px!important',
        // },
        '.DatePickerIcon': {
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
          },
        },
        '.MuiStack-root.MuiMultiInputDateRangeField-root>:not(style)~:not(style)': {
          [theme.breakpoints.down('sm')]: {
            marginTop: '16px',
          },
        },
        '.DatePickerIcon .MuiTextField-root': {
          backgroundImage: `url(
            ${require(`./assets/images/calendar-today-outlined-icon.png`)}
          )`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center right 12px',
          [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
          },
        },
        '.BasicDatePickerIcon': {
          width: '100%',
        },
        '.BasicDatePickerIcon .MuiInputAdornment-root .MuiButtonBase-root svg': {
          visibility: 'hidden',
        },
        '.BasicDatePickerIcon .MuiInputAdornment-root .MuiButtonBase-root': {
          backgroundImage: `url(
            ${require(`./assets/images/calendar-today-outlined-icon.png`)}
          )`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
        },
        '.CustomIconButton:hover svg path': {
          fill: '#fff',
        },
        '.MainHeading': {
          fontWeight: theme.typography.fontWeightMedium,
        },
        '.SubHeading': {
          marginTop: '12px',
        },
        '.DialogHeading': {
          // fontWeight: theme.typography.fontWeightMedium,
          marginBottom: '5px',
        },
        '.DialogSubHeading': {
          fontWeight: theme.typography.fontWeightMedium,
        },
        '.DialogDivider': {
          marginTop: '0px',
          marginBottom: '0px',
        },
        '.HeadingBoxContainer': {
          // position: 'sticky',
          // top: '74px',
          // zIndex: '999',
          backgroundColor: '#fff',
        },

        // '.FixedTable': {
        //   position: 'sticky',
        //   top: '116px',
        // },
        // '.ChildrenBox': { height: 'calc(100% - 74px)' },
        '.FilterBox': {
          padding: '12px 16px',
          width: '100%',
          // position: 'sticky',
          // top: 'calc(74px + 88px)',
          // zIndex: '999',
          // backgroundColor: '#fff',
        },

        '.HeadingBox': {
          padding: '22px 16px',
          // marginBottom: '16px',
          // borderBottom: '1px solid',
          // borderColor: theme.palette.divider,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderRadius: '0px',
        },
        '.AlignStart': {
          alignItems: 'start',
        },
        '.HeadingBorder': {
          borderBottom: '1px solid',
          borderColor: theme.palette.divider,
        },
        '.FooterBorderTop': {
          borderTop: '1px solid',
          borderColor: theme.palette.divider,
        },
        '.CommonFullBorder': {
          border: '1px solid',
          borderColor: theme.palette.divider,
        },
        '.BgGreySecondary': {
          backgroundColor: theme.palette.background.paper,
          borderRadius: '4px',
        },
        '.BgGreyPrimary': {
          backgroundColor: theme.palette.background.dark,
        },
        '.FlexCenter': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '.FlexCenterCorner': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        },
        '.GrayBorderPaper': {
          border: '2px solid',
          borderColor: theme.palette.divider,
          padding: '24px',
        },
        '.GrayBorderPaperWhiteBg': {
          border: '2px solid',
          borderColor: theme.palette.divider,
          padding: '40px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '4px',
        },
        '.ResponsiveImage': {
          width: '100%',
          height: 'auto',
          maxHeight: '100%',
          objectFit: 'cover',
          borderRadius: '8px',
          aspectRatio: '1/1',
        },
        '.HidePagination': {
          '& .MuiDataGrid-footerContainer': {
            display: 'none',
          },
        },
        '.MuiDataGrid-toolbarContainer .MuiButtonBase-root.MuiButton-root': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: theme.palette.primary.main,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.primary.hover,
          },
        },
        '.MuiDataGrid-panelHeader .MuiFormControl-root.MuiTextField-root': {
          display: 'none',
        },
        '.MuiDataGrid-menu .MuiPaper-root': {
          borderRadius: '4px',
          boxShadow:
            '0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important',
        },
        '.DrawerHeaderBox': {
          minHeight: '74px',
        },
        '.CommonActionList .MuiButtonBase-root.MuiListItemButton-root': {
          // borderBottom: '1px solid',
          // borderColor: theme.palette.divider,
          maxHeight: '36px',
        },
        // '.CommonActionList .MuiButtonBase-root.MuiListItemButton-root:last-child': {
        //   borderBottom: 'none',
        // },
        '.CommonActionList .MuiListItem-root': {
          borderBottom: '1px solid',
          borderColor: theme.palette.divider,
          paddingLeft: '2px',
          paddingRight: '2px',
        },
        '.CommonToolbarList .MuiListItem-root': {
          borderBottom: '1px solid',
          borderColor: theme.palette.divider,
          paddingLeft: '2px',
          paddingRight: '2px',
        },
        '.CommonSubToolbarList .MuiListItem-root': {
          paddingLeft: '2px',
          paddingRight: '2px',
        },
        '.CommonActionList .MuiListItem-root:last-child, .CommonToolbarList .MuiListItem-root:last-child':
          {
            borderBottom: 'none',
          },
        '.TimeEntrycardTitle': {
          borderBottom: '1px solid #a7cad4',
          cursor: 'pointer',
          '&:hover': {
            borderBottomColor: '#247a94',
          },
        },
        '.AvatarInitials': {
          width: 100,
          height: 100,
          background: 'rgba(18, 66, 105, 1)',
          textTransform: 'uppercase',
        },
        '.AvatarInitials40': {
          width: 40,
          height: 40,
          background: 'rgba(18, 66, 105, 1)',
          textTransform: 'uppercase',
        },
        '.DragDropContainer': {
          /* minHeight: '160px', */
          border: '1px dashed rgba(0, 0, 0, 0.12)',
          borderRadius: '4px',
          '& .MuiTypography-h4': {
            fontFamily: '"Roboto", sans-serif',
            fontWeight: '400',
            color: 'rgba(0, 0, 0, 0.87)',
          },
          '& .MuiTypography-body1': {
            fontFamily: '"Roboto", sans-serif',
            color: 'rgba(0, 0, 0, 0.6)',
          },
        },
        '.DragDropSection': {
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          cursor: 'pointer',
        },
        '.DragDropLink': {
          color: 'rgba(30, 107, 170, 1)',
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '.ImageCropperSection': {
          '& .MuiDialogContent-root': {
            border: 'none',
            '& .reactEasyCrop_CropArea': {
              color: '#fff',
            },
          },
        },
        '.EmployeeExistsDetails': {
          borderRadius: '8px',
          border: '2px solid #1E6BAA',
          background: 'rgba(30, 107, 170, 0.08)',
        },
        '.DialogSmall': {
          '& .MuiButton-root': {
            fontSize: '14px',
          },
        },
        '.BorderlessTextField': {
          '& .MuiOutlinedInput-root': {
            opacity: '1',
            '& .MuiInputBase-input': {
              WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
            },
            '& fieldset': {
              border: 'none',
            },
          },
        },
        '.EmployeeListTable': {
          '& .MuiDataGrid-cell:first-child': {
            textTransform: 'capitalize',
          },
        },
        '.EmployeeListTableNoCaps': {
          '& .MuiDataGrid-cell:first-child': {
            textTransform: 'none',
          },
        },
        '.SiteListTable': {
          '& .MuiDataGrid-cell:first-child': {
            textTransform: 'none',
          },
        },
        '.noCapatilize': {
          textTransform: 'none',
        },
        '.ZoomController': {
          width: '30%',
        },
        '.clampedText': {
          display: '-webkit-box',
          WebkitLineClamp: '4' /* Show only 4 lines */,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        textarea: {
          '&[disabled]': {
            background: 'rgba(0, 0, 0, 0.04)',
            borderColor: 'transparent',
          },
        },
        '.BottomButtonSection': {
          position: 'fixed',
          bottom: '0',
          width: 'calc(100% - 240px)',
          right: '0',
          background: '#fff',
          padding: '16px 32px 24px 32px',
          borderTop: '1px solid rgba(0, 0, 0, 0.12)',
          zIndex: '1',
          '@media screen and (min-device-width: 320px) and (max-device-width: 1024px)': {
            width: '100% !important',
          },
        },
        '.AppLayoutNavClose .BottomButtonSection': {
          width: 'calc(100% - 65px)',
        },
        '.GuidelinesTextarea textarea': {
          height: '180px !important',
          overflowY: 'auto',
        },
        '.OptionalContacts': {
          background: 'rgba(30, 107, 170, 0.08)',
          border: '2px solid rgba(30, 107, 170, 1)',
          borderRadius: '8px',
          padding: '16px',
        },
        '.InputTypeTextarea textarea.MuiInputBase-inputMultiline': {
          overflow: 'auto!important',
          maxHeight: '85px!important',
        },
        '.TimePickerWrapper .MuiFormControl-root': {
          width: '100%',
        },
        '.custom-quill-editor .ql-editor': {
          minHeight: '200px' /* Set the desired height here */,
          maxHeight: '200px' /* Set the desired height here */,
          overflowY: 'auto',
        },
        /* Add border to all alignment buttons */
        '.custom-quill-editor .ql-toolbar button': {
          '&:hover': {
            background: 'rgba(30, 107, 170, 0.08)',
          },
        },
        '.custom-quill-editor .ql-toolbar .ql-align': {
          height: '40px',
          width: '40px',
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        },
        '.custom-quill-editor .ql-toolbar .ql-list': {
          height: '40px',
          width: '40px',
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        },
        '.custom-quill-editor .ql-toolbar .ql-align .ql-stroke': {
          stroke: 'rgba(0, 0, 0, 0.56)',
        },
        '.custom-quill-editor .ql-toolbar .ql-align-center': {
          border: '1px solid #ccc',
        },
        '.custom-quill-editor .ql-toolbar .ql-align-right': {
          border: '1px solid #ccc',
        },
        '.custom-quill-editor .ql-toolbar .ql-align-justify': {
          border: '1px solid #ccc',
        },
        '.ql-editor': {
          fontSize: '16px',
          color: 'rgba(0, 0, 0, 0.6)',
        },
        '.ql-editor.ql-blank::before': {
          fontSize: '16px',
          fontStyle: 'normal !important',
        },
        '.PopoverButtonStyle': {
          color: 'rgba(0, 0, 0, 0.87)',
          justifyContent: 'flex-start',
          textTransform: 'none',
          fontWeight: '400',
          '& .MuiButton-startIcon': {
            color: 'rgba(0, 0, 0, 0.56)',
          },
        },
        '.LinkText': {
          color: 'rgba(30, 107, 170, 1)',
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '.LinkTextNonPointer': {
          color: 'rgba(30, 107, 170, 1)',
          textDecoration: 'underline',
        },
        '.IconStyle': {
          color: 'rgba(158, 158, 158, 1)',
          fontSize: '8px',
        },

        '.PatrolTaskList': {
          background: '#fafafa',
          borderRadius: '10px',
        },

        '.NoPatrolTaskList': {
          marginTop: '-5px',
        },
        '.ql-toolbar.ql-snow': {
          borderBottom: 'none !important',
          borderRadius: '4px 4px 0 0',
        },
        '.ql-container.ql-snow': {
          borderRadius: '0 0 4px 4px',
        },
        '.AlignmentButtonGroup.ql-align-group': {
          display: 'inline-block',
          margin: '4px 7px auto 4px',
          borderRadius: '4px',
        },
        '.AlignmentButtonGroup.ql-align-group button': {
          border: '1px solid #ccc !important',
          height: 'auto  !important',
          padding: '5px 10px  !important',
          width: 'auto  !important',
        },
        '.AlignmentButtonGroup.ql-align-group button:first-child': {
          borderRight: 'none !important',
        },
        '.AlignmentButtonGroup.ql-align-group button:last-child': {
          borderRight: '1px solid #ccc !important',
        },
        '.AlignmentButtonGroup button:focus-visible': {
          outline: '0px !important',
        },
        '.InstructionsDetail': {
          ul: {
            margin: 0,
            padding: '3px 0 0 25px',
          },
          p: {
            overflowWrap: 'break-word',
          },
        },
        '.NotesDetail': {
          ul: {
            margin: 0,
            padding: '3px 0 0 25px',
          },
          p: {
            overflowWrap: 'break-word',
          },
        },
        '.SecurityPhotosUpload': {
          border: '1px solid #1E6BAA',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          position: 'relative',
          aspectRatio: '1/1',
          input: {
            height: '100%',
            width: '100%',
            position: 'absolute',
            opacity: '0',
            cursor: 'pointer',
          },
        },
        '.ImageDelete': {
          position: 'absolute',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          background: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '8px',
          opacity: '0',
        },
        '.ImageDeleteWrapper': {
          position: 'relative',
          '&:hover': {
            '.ImageDelete': {
              opacity: '1',
            },
          },
        },

        '@media screen and (min-device-width: 1200px)': {
          '.FixedTable .MuiDataGrid-virtualScrollerContent': {
            maxHeight: 'calc(100vh - 100px) !important',
            minHeight: 'calc(100vh - 100px) !important',
          },
          '.TableContainer .MuiDataGrid-virtualScroller': {
            // maxHeight: 'calc(100% - 400px)',
            overflow: 'visible',
          },
          '.TableContainer': {
            height: 'calc(100% - 116px)',
            position: 'sticky',
            top: '116px',
            // zIndex: '999',
            // height: '600px',
          },
        },
        '@media screen and (max-device-width: 1199px)': {
          '.TableContainer': {
            height: '400px',
          },
        },
        '@media screen and (min-device-width: 768px) and (max-device-width: 1019px)': {},
        '@media screen and (min-device-width: 320px) and (max-device-width: 1019px)': {},
        '@media screen and (min-device-width: 320px) and (max-device-width: 600px)': {
          '.PageContainerSmallInner': {
            padding: '0',
          },
          /* '.EmployeeListTable': {
            '& .MuiDataGrid-columnHeader.headerEmail': {
              display: 'none',
            },
            '& .MuiDataGrid-cell.hideOnMobile': {
              display: 'none',
            },
          }, */
          '.ZoomController': {
            width: '70%',
          },
          iframe: {
            height: '200px',
            width: '100%',
          },
        },
        '@media screen and (min-device-width: 320px) and (max-device-width: 1200px)': {},
      }}
    />
  );
};

export default MainStyles;
